import { ENVIRONMENT } from "../../constants"
/** Set to true to display a loading indicator whilst the
 * allowed filters for the current user are being loaded
 */

export function changeValueAppraisalLevels(selectedValues, displayText, scrollTop) {
  return {
    type: "CHANGE_VALUE_APPRAISAL_LEVELS",
    selectedValues,
    displayText,
    scrollTop,
  }
}

export function changeValueDataMode(newValue) {
  return {
    type: "CHANGE_VALUE_DATA_MODE",
    payload: {
      request: {
        url: `/reporting/filters/filter-options-data-mode-changed?mode=${newValue}`,
      },
    },
  }
}

export function changeValueEndDate(newValue) {
  return { type: "CHANGE_VALUE_END_DATE", newValue }
}

export function changeValueGenerations(selectedValues, displayText, scrollTop) {
  return {
    type: "CHANGE_VALUE_GENERATIONS",
    selectedValues,
    displayText,
    scrollTop,
  }
}

export function changeValueGenders(selectedValues, displayText, scrollTop) {
  return {
    type: "CHANGE_VALUE_GENDERS",
    selectedValues,
    displayText,
    scrollTop,
  }
}

export function changeValueJobTitles(selectedValues, displayText, scrollTop) {
  return {
    type: "CHANGE_VALUE_JOB_TITLES",
    selectedValues,
    displayText,
    scrollTop,
  }
}

export function changeValueLocations(selectedValues, displayText) {
  return { type: "CHANGE_VALUE_LOCATIONS", selectedValues, displayText }
}

export function changeValueStartDate(newValue) {
  return { type: "CHANGE_VALUE_START_DATE", newValue }
}

export function changeValueReview(newValue) {
  return { type: "CHANGE_VALUE_REVIEW", newValue }
}

export function changeValueViewMode(newValue) {
  return { type: "CHANGE_VALUE_VIEW_MODE", newValue }
}

export function changeManagerFilter(newValue) {
  return { type: "CHANGE_VALUE_MANAGER", newValue }
}

export function clearManagerFilter() {
  return { type: "CLEAR_VALUE_MANAGER" }
}

export function configureViewModeForUser(user) {
  return { type: "CONFIGURE_VIEW_MODE_FOR_USER", user }
}

function errorLoadingAvailableFilterListOptions(error) {
  return { type: "ERROR_LOADING_AVAILABLE_FILTER_LIST_OPTIONS", error }
}

function receiveAvailableFilterListOptions(data) {
  return { type: "RECEIVE_FILTER_LIST_OPTIONS", data }
}

function requestAvailableFilterListOptions() {
  return { type: "REQUEST_FILTER_LIST_OPTIONS" }
}

export function resetAllFilters() {
  return { type: "RESET_ALL_FILTERS" }
}

export function setActiveField(fieldKey) {
  return { type: "SET_ACTIVE_FIELD", fieldKey }
}

/** Set whether the full screen filters are displayed or not */
export function toggleFullScreenFilters(isVisible) {
  return { type: "SET_FULLSCREEN_FILTERS_VISIBLE", isVisible }
}

/** Whether filters are open (pinned) or hidden to the side (unpinned) */
export function toggleFiltersPinned(isPinned) {
  return { type: "SET_FILTERS_PINNED", isPinned }
}

/** Set whether the advanced filters in the sidebar is expanded or not */
export function setAdvancedFiltersOpen(isOpen) {
  return { type: "SET_ADVANCED_FILTERS_OPEN", isOpen }
}

/** Triggers the three states of loading filter options - request begun, successful and fail.
 * Calls the API and passes output to the relevant reducer on success
 */
export function loadAvailableFilterListOptionsDummy() {
  return (dispatch) => {
    dispatch(requestAvailableFilterListOptions())

    // TODO: replace this with a real API call...perhaps with Redux Axios Middleware
    // (https://github.com/svrcekmichal/redux-axios-middleware) if we use that
    // for dashboard loading
    const getFilterOptionsFromApi = new Promise((resolve, reject) => {
      const dummyRequestStatusSuccess = true
      if (dummyRequestStatusSuccess) {
        const dummyData = {
          appraisalLevels: [
            { label: "App Lvl 1", value: "1", selected: false },
            { label: "App Lvl 2", value: "2", selected: false },
            { label: "App Lvl 3", value: "3", selected: false },
            { label: "App Lvl 4", value: "4", selected: false },
            { label: "App Lvl 5", value: "5", selected: false },
            { label: "App Lvl 6", value: "6", selected: false },
            { label: "App Lvl 7", value: "7", selected: false },
            { label: "App Lvl 8", value: "8", selected: false },
            { label: "App Lvl 9", value: "9", selected: false },
            { label: "App Lvl 10", value: "10", selected: false },
            { label: "App Lvl 11", value: "11", selected: false },
            { label: "App Lvl 12", value: "12", selected: false },
            { label: "App Lvl 13", value: "13", selected: false },
            { label: "App Lvl 14", value: "14", selected: false },
            { label: "App Lvl 15", value: "15", selected: false },
          ],
          generations: [
            { label: "Silent Generation", value: "SILENT_GENERATION", selected: false },
            { label: "Baby Boomers", value: "BABY_BOOMERS", selected: false },
            { label: "Generation X", value: "GENERATION_X", selected: false },
            { label: "Millenials", value: "MILLENIALS", selected: false },
            { label: "Generation Z", value: "GENERATION_Z", selected: false },
          ],
          jobTitles: [
            { label: "Job Title A", value: "1", selected: false },
            { label: "Job Title B", value: "2", selected: false },
            { label: "Job Title C", value: "3", selected: false },
            { label: "Job Title D", value: "4", selected: false },
            { label: "Job Title E", value: "5", selected: false },
            { label: "Job Title F", value: "6", selected: false },
          ],
          locations: [
            {
              value: 1,
              label: "Europe",
              children: [
                { value: 10, label: "France", children: [] },
                { value: 11, label: "Spain", children: [] },
                {
                  value: 12,
                  label: "United Kingdom",
                  children: [
                    {
                      value: 34,
                      label: "Kent",
                      children: [{ value: 45, label: "Maidstone", children: [] }],
                    },
                    { value: 35, label: "London", children: [] },
                    { value: 36, label: "Sussex", children: [] },
                  ],
                },
              ],
            },
            {
              value: 2,
              label: "America",
              children: [
                { value: 20, label: "Brazil", children: [] },
                { value: 21, label: "Peru", children: [] },
                { value: 22, label: "USA", children: [] },
              ],
            },
          ],
          reviews: [
            { label: "None", value: "-1", selected: true },
            { label: "Performance Review 2018", value: "33", selected: false },
            { label: "Performance Review 2017", value: "22", selected: false },
            { label: "Performance Review 2016", value: "11", selected: false },
          ],
          managers: [
            {
              employeeId: 1,
              name: "Mark Doran",
              location: "Office",
              jobTitle: "Senior Developer",
              statusId: 1,
              statusTranslationIdentifier: "",
            },
            {
              employeeId: 2,
              name: "Steve Kennaird",
              location: "Home",
              jobTitle: "Technical Director",
              statusId: 1,
              statusTranslationIdentifier: "",
            },
            {
              employeeId: 3,
              name: "Alex Haigh",
              location: "Everywhere",
              jobTitle: "Developer",
              statusId: 1,
              statusTranslationIdentifier: "",
            },
            {
              employeeId: 4,
              name: "Sean Yearsley",
              location: "America",
              jobTitle: "Developer",
              statusId: 1,
              statusTranslationIdentifier: "",
            },
            {
              employeeId: 5,
              name: "Sean McSweeney",
              location: "Waiting for a train",
              jobTitle: "Junior Developer",
              statusId: 1,
              statusTranslationIdentifier: "",
            },
          ],
        }

        resolve(dummyData)
      } else {
        reject(new Error("Unable to load filter options from the API"))
      }
    })

    getFilterOptionsFromApi
      .then(data => dispatch(receiveAvailableFilterListOptions(data)))
      .catch(error => dispatch(errorLoadingAvailableFilterListOptions(error)))
  }
}

export function loadAvailableFilterListOptions() {
  if (!ENVIRONMENT.useDummyData()) {
    return {
      type: "LOADFILTERS",
      payload: {
        request: {
          url: "/reporting/filters/filter-options",
        },
      },
    }
  }
  return loadAvailableFilterListOptionsDummy()
}



// WEBPACK FOOTER //
// ./src/state/actions/filterActions.js